module.exports = __webpack_public_path__ + "img/icon-communication.7f9ee28b.svg";